<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <br />
                        <a href="/card" class="link" style="text-decoration:none;">
                            <i class="bi bi-chevron-left"></i>
                        </a>
                    </div>
                    <div class="col text-center" style="padding-top: 25px;">
                        <b>好みのカード 検索結果</b>
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <div class="container-fluid" style="padding-top:70px;">
                <br>
                <div class="row">
                    <div class="col">
                        <input type="text" class="form-control" @keypress.enter="setWord" v-model="search_word"
                            placeholder="キーワードを入力">
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-4 px-0" v-for="card in cards" :key="card.id">
                        <a :href="'/card/detail/' + card.id">
                            <div style="margin:8px;">
                                <img :src="card.thumbnail_image" class="rounded img-fluid">
                                <div><small>{{ card.name }}</small></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row" v-if="count != 0">
                    <div class="col">
                        <div class="text-center" style="padding-top: 40px; padding-bottom: 20px; color: #6c7072"
                            v-if="is_page && count != 0">
                            <a @click="fetchCardMore()">もっとみる</a>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="is_load_under">
                    <div class="col text-center">
                        <div class="spinner-grow" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <br>
                <br>
                <br>
            </div>
        </div>
        <FooterMenu currentPage="card" />
    </div>
</template>

<script>
import FooterMenu from '../components/FooterMenu.vue';

export default {
    components: {
        FooterMenu,
    },
    data() {
        return {
            cards: [],
            count: 0,
            page: 1,
            is_load: true,
            is_load_under: false,
            is_page: true,
            search_word: "",
            search_word_tmp: "",
        };
    },
    mouted: function () {
        window.addEventListener("scroll", this.handleScroll)
    },
    methods: {
        setWord() {
            this.fetchCard()

            this.search_word_tmp = this.search_word
        },
        async fetchCard() {
            await axios.post("/api/card/find", {
                search_word: this.search_word,
            })
                .then((response) => {
                    this.cards = response.data.cards.data
                    this.count = response.data.count

                    if (this.count <= 9) {
                        this.is_page = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カードの取得に失敗しました。")
                    }
                })
        },
        async fetchCardMore() {
            this.is_load_under = true
            this.page++

            await axios.post("/api/card/find?page=" + this.page, {
                search_word: this.search_word,
            })
                .then((response) => {
                    this.cards.push.apply(this.cards, response.data.cards.data)

                    if (response.data.cards.data.length == 0) {
                        this.is_page = false
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("カードの取得に失敗しました。")
                    }
                }).finally(() => {
                    this.is_load_under = false
                })
        },
        async handleScroll() {
            let bottom = document.body.scrollHeight - document.body.clientHeight

            this.scrollY = window.scrollY
            let p = Math.abs(bottom - this.scrollY)

            if (p < 1 && this.is_page) {
                this.fetchCardMore()
            }
        }
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.search_word = localStorage.getItem('search_word')
                            this.fetchCard()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました。")
                    })
            }
            else {
                this.search_word = localStorage.getItem('search_word')
                this.fetchCard()
            }
        }
        else {
            this.search_word = localStorage.getItem('search_word')
            this.fetchCard()
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll)
    },
};
</script>

<style scoped>
a {
    text-decoration: none;
    color: #000;
}

.category-box {
    padding: 25px 10px;
    background-color: #6b4eff;
    color: #fff;
    border-radius: 8px;
}

.category-box-filter {
    padding: 25px 10px;
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
    border-radius: 8px;
}

.category-header {
    padding: 45px 10px;
    background-color: #6b4eff;
    color: #fff;
}

.category-header-filter {
    padding: 45px 10px;
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
}

.luna-footer-card-menu {
    position: fixed;
    bottom: 0;
    width: 538px;
    height: 80px;
    background-color: #fff;
    padding-top: 15px;
    z-index: 99999;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }

    .luna-footer-card-menu {
        width: 100%;
    }
}
</style>
